import React, { FC } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { styled, Typography } from '@mui/material'
import { Box } from '@mui/material'

export interface MarkdownProps {
  text?: string
  theme?: 'mui' | 'plain'
}

const MarkdownContainer = styled(Box, {
  name: 'MarkdownContainer',
})(({ theme }) => ({
  'h1, h2, h3, h4, h5, h6': {
    marginBottom: theme.spacing(2),
  },
  'p, ul, ol': {
    marginBottom: '1em',
  },
  'ul, ol': {
    paddingInlineStart: theme.spacing(4),
  },
  li: {
    marginBottom: '0.5em',
  },
}))

export const Markdown: FC<MarkdownProps> = React.forwardRef<
  HTMLDivElement,
  MarkdownProps
>(({ text, theme = 'mui' }, ref) =>
  text ? (
    <MarkdownContainer ref={ref}>
      <ReactMarkdown
        components={
          theme === 'mui'
            ? {
                h1: ({ ...props }) => <Typography variant="h1" {...props} />,
                h2: ({ ...props }) => <Typography variant="h2" {...props} />,
                h3: ({ ...props }) => <Typography variant="h3" {...props} />,
                h4: ({ ...props }) => <Typography variant="h4" {...props} />,
                h5: ({ ...props }) => <Typography variant="h5" {...props} />,
                h6: ({ ...props }) => <Typography variant="h6" {...props} />,
                p: ({ ...props }) => <Typography variant="body1" {...props} />,
              }
            : {}
        }
        remarkPlugins={[remarkGfm]}
      >
        {text}
      </ReactMarkdown>
    </MarkdownContainer>
  ) : null
)

if (process.env.NODE_ENV !== 'production') {
  Markdown.displayName = 'Markdown'
}
